// extracted by mini-css-extract-plugin
module.exports = {"input":"Menu_input__Ll7Pz","label":"Menu_label__3Z2kN","menuWithScroll":"Menu_menuWithScroll___94q_"};